import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'
import {Nav, Navbar, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'
import ShowMoreText from "react-show-more-text";
import Truncate from 'react-show-more-text/lib/Truncate';
import moment from 'moment'
import copy from 'copy-to-clipboard';
import { ReactDialogBox } from 'react-js-dialog-box'
import 'react-js-dialog-box/dist/index.css'
import ViewNote from '../view-note/ViewNote';

const Styles = styled.div `

    // - - NAVBAR - - //

.theNavbar {
    max-width: 95%;
}

.logo {
    font-family: Val;
    color: #99CC63;
    font-size: 30px;
    margin-left: 2%;
    cursor: pointer;
}

.logo:hover {
    color: #724E39;
}

.linkItem {
    max-width: 100%;
    margin-right: 15%;
    }

    // - - NAVBAR LINKS - - //

.navLinks {
    margin-right: 15%;
    color: #FF3C33;
    font-size: 20px;
    font-family: DM Sans;
}

.linkItem {
    margin-right: 50%;
}

.linkItem label {
    color: #99CC63;
    cursor: pointer;
}

.linkItem label:hover {
    color: #724E39;
}


    // - - HEADER - - //

.header {
    text-align: center;
}

.header h1 {
    font-family: DM Sans;
    color: #724E39;
}

.header button {
    padding: 1%;
    background-color: #99CC63;
    color: #724E39;
    font-family: DM Sans;
    outline: none;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-weight: bold;
    margin-top: 1%;
}

    // - - CATEGORY BUTTONS - - //

.categoryBtns:after {
    content: "";
    display:table;
    clear: both;
}

.categoryBtns {
    margin-top: 5%;
}

.cBtn {
    width: 50%;
    text-align: center;
    float: left;
}

.cBtn button {
    padding: 1%;
    width: 150px;
    border-radius: 8px;
    height: 50px;
    font-size: 20px;
    font-family: DM Sans;
}

    // - - ALL TASKS - - //

.allTasks {
    padding-top: 2%;
    background: linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
    text-align: center;
    border: 0px solid black;
    border-radius: 8px;
    margin-bottom: %;
    margin-top: 2%;
    margin-left: 15%;
    margin-right: 15%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskInfo:after {
    content: "";
    display:table;
    clear: both;
}

.taskInfo {
    // margin-top: 5%;
}

.taskLabel {
    width: 20%;
    text-align: center;
    float: left;
    margin-top: 1.25%;
}

.taskData {
    width: 60%;
    text-align: center;
    float: left;
    margin-top: 1%;
}

.taskDataChild {
    margin-right: 0%;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskDataChild2 {
    margin-right: 5%;
}

.taskDataChild2 p {
    font-size: 15px !important;
    margin-bottom: 0px !important;
}

.taskDifficulty {
    width: 30%;
    text-align: center;
    float: left;
    margin-top: 1%;
}

.taskLabel h5 {
    font-family: DM Sans;
    font-size: 18.5px;
}

.taskData p {
    text-align: left;
    font-family: Poppins;
    font-size: 17.5px;
    margin-right: 5%;
    margin-bottom: 0.5%;
    padding: 0.5%;
    margin-left: 1%;
}

.taskData textarea {
    width: 100%;
    padding: 5px;
    font-family: DM Sans;
    margin-right: 5%;
    border-radius: 8px;
    height: 95px;
    resize: none;
    border: 2px solid transparent;
    outline: none;
    // overflow-y: scroll;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskDifficulty label {
    text-align: justify;
    float: left;
    font-family: DM Sans;
}

.taskCategory {
    text-align: center;
}

.taskCategory p {
    float: left;
    font-size: 18.5px;
    font-family: DM Sans;
    font-weight: bold;
}


.taskCategory label {
    text-align: center;
}

.markComplete h4 {
    color: transparent;
}

    // - - TASK BUTTON ACTIONS - - //

.taskBtnAction {
    text-align: left;
    margin-left: 6%;

}

.taskBtnAction2 {
    text-align: center;
    // margin-left: 7%;
}

.taskBtnAction button {
    background-color: white;
    border-radius: 8px;
    font-family: DM Sans;
    font-weight: bold;
    padding: 1%;
    margin-top: 1%;
    border: 2px solid transparent;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskBtnAction h5 {
    font-size: 16px;
    margin-bottom: 0px;
    margin-top: 1%;
}

.taskBtnAction2 button {
    border: 2px solid transparent;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    width: 150px;
}

.taskBtnAction2 p {
    margin-top: 2.5%;
    margin-bottom: 1%;
    font-family: DM Sans;
    color: white;
    font-weight: bold;
    font-size: 18px;
}

.taskBtnAction2 textarea {
    resize: none;
    lines: 4;
    width: 60%;
    padding: 5px;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border: 2px solid transparent;
    outline: none;
    text-align: left;
    font-family: DM Sans;
    font-size: 17.5px;
}

    // - - EXAMPLE LIST - - //

.exampleList h4 {
    font-family: DM Sans;
    color: white;
}

.exampleList p {
    font-family: DM Sans;
    color: white;
    font-weight: bold;
}

    // - - HIDE ITEMS - - //

.hideItems {
    text-align: right;
}

.hideItems button {
    height: 0px;
    padding: 0%;
    margin-right: 3%;
    font-size: 15px;
    color: white;
    background-color: transparent;
    border: 2px solid transparent;
    padding-bottom: 0px;
    padding-top: 0px;
}


    // - - NOTE - - //

.noteContainer {
    // margin-top: 3%;
    text-align: center;
    margin-bottom: 4%;
}

.noteContainer h4 {
    text-align: center;
    margin-top: 4%;
    margin-bottom: 4%;
    // margin-left: 5%;
    // margin-right: 5%;
    // text-align: justify;
    font-size: 19.5px;
    font-family: DM Sans;
    color: #00;
}

.noteContainer img {
    width: 500px;
}

.note {
    margin-left: 15%;
    margin-right: 15%;
    margin-top: 1%;
}

.note p {
    text-align: left;
    font-family: DM Sans;
    font-weight: bold;
    color: #724E39;
    margin-bottom: 3.5px;
    margin-top: 3%;
    font-size: 18.5px;
}

.note textarea {
    width: 100%;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
    resize: none;
    padding: 1.5%;
    outline: none;
}

.noteButtons:after {
    content: "";
    display:table;
    clear: both;
}

.noteButtons {
    margin-top: 1%;
}

.noteButtons h5 {
    font-size: 17.5px;
    color: #724E39;
    font-family: DM Sans;
}

.noteBtn {
    width: 50%;
    text-align: center;
    float: left;
}

.noteBtn button {
    background-color: #F5DE89;
    color: #724E39;
    border: 2px solid #F5DE89;
    font-size: 15px;
    font-family: DM Sans;
    padding: 2%;
    width: 100px;
    font-weight: bold;
    border-radius: 8px;
}

.modalDialogBox {
}


.maximizeDialogBox {
    height: 100%;
    text-align: center;
}

.maximizeDialogBox video {
    width: 80%;
}

.maximizeDialogBox h4 {
    font-family: DM Sans;
    color: #724E39;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0%;
}

.maximizeDialogBox p {
    margin-top: 1%;
    color: #724E39;
    font-family: DM Sans;
}



// - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {

        // - - NAVBAR LINKS - - //

    .linkItem label {
        margin-left: 5%;
    }

        // - - HEADER - - //

    .header button {
        padding: 3%;
    }


        // - - THE LIST - - //

    .theList button {
        padding: 3%;
        margin-bottom: 10%;
    }

    .theList h3 {
        text-align: justify;
        margin-left: 5%;
        margin-top: 1%;
        font-family: DM Sans;
    }

        // - - CATEGORY BUTTONS - - //

    .categoryBtns {
        margin-bottom: 5%;
    }

        // - - ALL TASKS - - //

    .allTasks {
        margin-bottom: 5%;
        margin-top: 2%;
        margin-left: 5%;
        margin-right: 5%;
    }

    .taskLabel {
        width: 100%;
        margin-left: 3%;
    }

    .taskData {
        width: 100%;
        font-weight: bold;
        margin-left: 3%;
        margin-right: 5%;
    }

    .taskDataChild {
        width: 94%;
    }

    .taskDifficulty {
        width: 100%;
        margin-left: 3%;
    }

    .taskDifficulty button {
        font-size: 14.5px;
    }

    .taskLabel h5 {
        margin-top: 3.5%;
        font-size: 16.75px;
        text-align: left;
        margin-bottom: 1%;
        margin-left: 2%;
    }

    .taskData p {
        font-family: DM Sans;
        padding-top: 1%;
        padding-bottom: 1%;
        font-size: 14.5px;
        margin-bottom: 1%;
        margin-left: 1.5%;
    }

        // - - TASK BUTTON ACTIONS - - //

    .taskBtnAction {
        text-align: left;
        margin-left: 3%;
        margin-top: 3%;
    }

    .taskBtnAction h5 {
        margin-bottom: 3%;
    }

    .taskBtnAction button {
        margin-bottom: 5px;
    }

        // - - MARK COMPLETE - - //

    .markComplete button {
        padding: 3%;
    }

        // - - ADD CONTAINER - - //

    .addContainer {
        margin-left: 5%;
        margin-right: 5%;
    }

        // - - ADD LABEL - - //

    .addLabel h5 {
        font-size: 10px;
    }

        // - - ADD INPUT - - //

    .addInput input {
        outline: none;
    }

        // - - ADD BUTTONS - - //

    .addContainer button {
        font-size: 9px;
    }

        // - - LAST ADD BUTTON - - //

    .lastAddBtn button {
        padding: 3%;
    }

        // - - SUCCESSFULL ADD BUTTON - - //

    .successfulAdd button {
        padding: 3%;
    }

        // - - TEXTAREA ADDING NOTES - - //

    .taskBtnAction2 button {
        margin-bottom: 5px;
    }

    .taskBtnAction2 textarea {
        width: 95%;
        font-size: 14.5px;
    }

        // - - HIDE ITEMS BUTTON - - //

    .hideItems button {
        font-size: 15px;
        padding-bottom: 5%;
        margin-bottom: 0px;
    }

        // - - NOTE - - //

    .noteContainer {
        margin-top: 5%;
        text-align: center;
    }

    .noteContainer h4 {
        text-align: justify;
        font-size: 17.5px;
        margin-left: 6%;
        margin-right: 6%;
        margin-top: 8%;
        margin-bottom: 8%;
    }

    .noteContainer img {
        width: 350px;
    }
    
    .note {
        margin-left: 0%;
        margin-right: 0%;
        margin-top: 4%;
    }

    .note p {
        margin-left: 3%;
    }

    .noteBtn {
        margin-bottom: 5%;
    }

    .noteBtn button {
        padding: 5%;
        width: 120px;
    }

        // - - DEMOS - - //

    .maximizeDialogBox h4 {
        font-size: 16px;
    }

    .maximizeDialogBox video {
        width: 100%;
    }

}





`

export default class Saves extends Component {
    constructor(){
        super()
        this.state = {

                // TOGGLES

            showTasks: false,
            docExsits: null,
            savesPage: true,
            viewingNote: false,

                // DEMOS

            taskDemo: false,
            taskTutorialSeen: null,
            noteDemo: false,
            noteTutorialSeen: null,

                // EMAIL
            userEmail: "",

                // TASK / NOTE CONTAINERS
            highPriorityTasks: [],
            lowPriorityTasks: [],
            userNotes: [],
            noteID: "",
            savesTitle: "Saves",

                // BUTTON COLORS
            noteBgColor: "white",
            noteTxtColor: "black",
            noteBrdrColor: "black",
            taskBgColor: "white",
            taskTxtColor: "black",
            taskBrdrColor: "black",

                // TASK ITEMS

            taskIcon: "",
            listErrMsg: ""
        }
    }

    componentDidMount = () => {
        this.authListener()
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.loadTutorials(user.email)
            } else {
                this.setState({user:null})
            }
        })
    }

    loadTutorials = (email) => {

            // - - TASK SAVE DEMO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("taskSaveDemo")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    taskTutorialSeen: doc.data().seen
                })
            }
        })

            // - - NOTE SAVE DEMO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("noteSaveDemo")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    noteTutorialSeen: doc.data().seen
                })
            }
        })
    }

    authListener = () => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    userEmail: user.email
                })
            } else {
                this.setState({user:null})
            }
        })
    }

    loadNotes = (email) => {
        class UserNote {
            constructor (copyBtn, copyMsg, date, deleting, id, note) {
                this.copyBtn = copyBtn
                this.copyMsg = copyMsg
                this.date = date
                this.deleting = deleting
                this.id = id
                this.note = note
            }
            toString() {
                return this.copyBtn + ', ' + 
                this.copyMsg + ', ' + 
                this.date + ', ' + 
                this.deleting + ', ' +
                this.id + ', ' +
                this.note
            }
        }
        var noteConverter = {
            toFirestore : function(note) {
                return {
                    copyBtn: note.copyBtn,
                    copyMsg: note.copyMsg,
                    date: note.date,
                    deleting: note.deleting,
                    id: note.id,
                    note: note.note
                }
            },
            fromFirestore: function (snapshot, options) {
                const data = snapshot.data(options)
                return new UserNote(data.copyBtn, data.copyMsg, 
                    data.date, data.deleting, data.id, data.note)
            }
        }
        fire.firestore().collection("users")
        .doc(email)
        .collection("/savedNotes")
        .withConverter(noteConverter)
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data())
            this.preConvertDates(data)
            this.setState({
                userNotes: data
            })
        })
    }

    sortByDate = (arr) => {
        arr.sort(function(a, b){
            var aa = a.date.split('/').reverse().join(),
                bb = b.date.split('/').reverse().join();
            return aa < bb ? -1 : (aa > bb ? 1 : 0);
            });
        if (arr.length != 0) {
            // Object.keys(arr).forEach((el) => {
            //     arr[el].date = arr[el].date.slice(0,-2) 
            // })
        } else {
            return
        }
    }

    preConvertDates = (arr) => {
        for (var i in arr) {
            arr[i].date = moment(arr[i].date).format('l')
            arr[i].date = this.convertDate(arr[i].date)
            if (arr[i].date.includes('/01/')) {
                arr[i].date = `${arr[i].date} - January`
            } else if (arr[i].date.includes('/02/')) {
                arr[i].date = `${arr[i].date} - February`
            } else if (arr[i].date.includes('/03/')) {
                arr[i].date = `${arr[i].date} - March`
            } else if (arr[i].date.includes('/04/')) {
                arr[i].date = `${arr[i].date} - April`
            } else if (arr[i].date.includes('/05/')) {
                arr[i].date = `${arr[i].date} - May`
            } else if (arr[i].date.includes('/06/')) {
                arr[i].date = `${arr[i].date} - June`
            } else if (arr[i].date.includes('/07/')) {
                arr[i].date = `${arr[i].date} - July`
            }else if (arr[i].date.includes('/08/')) {
                arr[i].date = `${arr[i].date} - August`
            } else if (arr[i].date.includes('/09/')) {
                arr[i].date = `${arr[i].date} - September`
            } else if (arr[i].date.includes('/10/')) {
                arr[i].date = `${arr[i].date} - October`
            } else if (arr[i].date.includes('/11/')) {
                arr[i].date = `${arr[i].date} - November`
            } else if (arr[i].date.includes('/12/')) {
                arr[i].date = `${arr[i].date} - December`
            }
        }
        arr = this.sortByDate(arr)
    }

    loadTasks = (email) => {
        class UserTask {
            constructor (category, deleting, difficulty, id, priority, task, taskErrMsg) {
                this.category = category
                this.deleting = deleting
                this.difficulty = difficulty
                this.id = id
                this.priority = priority
                this.task = task
                this.taskErrMsg = taskErrMsg
            }
            toString() {
                return this.category + ', ' +
                this.deleting + ', ' +
                this.difficulty + ', '+
                this.id + ', ' +
                this.priority + ', ' +
                this.task + ', ' +
                this.taskErrMsg
            }
        }
        var taskConverter = {
            toFirestore : function(task) {
                return {
                    category: task.category,
                    deleting: task.deleting,
                    difficulty: task.difficulty,
                    id: task.id,
                    priority: task.priority,
                    task: task.task,
                    taskErrMsg: task.taskErrMsg
                }
            },
            fromFirestore: function (snapshot, options) {
                const data = snapshot.data(options)
                return new UserTask(data.category, data.deleting,
                    data.difficulty, data.id, data.priority, data.task,
                    data.taskErrMsg)
            }
        }
        fire.firestore().collection("users")
        .doc(email)
        .collection("savedTasks")
        .withConverter(taskConverter)
        .where('priority', '==', 'High Priority')
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data())
            this.setState({
                highPriorityTasks: data
            })
        })

        fire.firestore().collection("users")
        .doc(email)
        .collection("savedTasks")
        .withConverter(taskConverter)
        .where('priority', '==', 'Low Priority')
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data())
            this.setState({
                lowPriorityTasks: data
            })
        })
    }

    taskAlreadyExists = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .update({
            taskErrMsg: "Task already exists in your to-do list 🦾"
        })
        this.loadTasks(this.state.userEmail)
    }

    taskHasBeenAdded = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .update({
            taskErrMsg: "Task has been added to your to-do list ✅"
        })
        this.loadTasks(this.state.userEmail)
    }

    checkExistingTask = (id, category, difficulty, priority, task) => {
        let newCategory = category.replace(/\s+/g, '')
        newCategory = category.replace(/[^a-z0-9]/gi, '');
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tasks")
        .doc(id)
        .get().then(doc => {
            if (!doc.exists) {
                this.addToList(id, newCategory, difficulty, priority, task)
                this.taskHasBeenAdded(id)
            } else {
                this.taskAlreadyExists(id)
                return;
            }
        })
    }

    executeOnClick = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .update({
            taskErrMsg: ""
        })
        this.loadTasks(this.state.userEmail)
    }

    addToList = (id, category, difficulty, priority, task) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tasks")
        .doc(id)
        .set({
            id: id,
            deleting: false,
            bgColorCode: "#F5DE89",
            txtColorCode: "#724E39",
            completeTaskBtn: "Task Completed",
            completeBtns: true,
            examples: false,
            exampleErrMsg: "",
            exampleList: false,
            exampleInput: false,
            greySetting: false,
            notes: "",
            saveBtn: false,
            saveNote: false,
            saveTask: true,
            task: task,
            taskIcon: "",
            minimizeStatus: false,
            difficulty: difficulty,
            category: category,
            priority: priority,
            completed: false
        })
    }

    deleteTaskPermanently = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .update({
            deleting: true
        })
        this.loadTasks(this.state.userEmail)
    }

    deleteTask = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id).delete()
        this.loadTasks(this.state.userEmail)
    }

    cancelDelete = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .update({
            deleting: false
        })
        this.loadTasks(this.state.userEmail)
    }

    renderHPTasks = () => {
        // this.loadTasks()
        if (this.state.highPriorityTasks.length!= 0) {
            return this.state.highPriorityTasks.map(tasks => {
                var {category, deleting,difficulty, 
                    id, priority, task, taskErrMsg} = tasks
                    
                if (category == "Relationships 🤝") {
                    this.state.taskIcon = "🤝"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🤝 💎"
                    }
                } else if (category == "Mental 🧠") {
                    this.state.taskIcon = "🧠"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🧠 💎"
                    }
                } else if (category == "Physical ❤️") {
                    this.state.taskIcon = "❤️"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "❤️ 💎"
                    }
                } else if (category == "Spiritual 🙏") {
                    this.state.taskIcon = "🙏"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🙏 💎"
                    }
                } else if (category == "General 📝") {
                    this.state.taskIcon = "📝"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "📝 💎"
                    }
                }


                if (deleting == false) {
                    this.state.showIncompleteBtn = true
                    this.state.confirmDelete = false
                } else {
                    this.state.showIncompleteBtn = false
                    this.state.confirmDelete = true
                }

                // if (completeBtns == false) {
                //     this.state.showIncompleteBtn = false
                // } else {
                //     this.state.showIncompleteBtn = true
                // }

                if (difficulty == "Challenging") {
                    difficulty = "🧨"
                } else if (difficulty == "Hard") {
                    difficulty = "🧨🧨"
                } else if (difficulty == "Very Hard") {
                    difficulty = "🧨🧨🧨"
                } else if (difficulty == "Super Hard") {
                    difficulty = "💣"
                }

                let taskTxtColor = {
                    fontFamily: "DM Sans"
                }

                let txtColor = {
                    color: "#724E39"
                }

                let taskCompleteLabel = {
                    marginLeft: "2%"
                }

                let completeBtnStyle = {
                    backgroundColor: this.state.taskCompleteBgColor,
                    color: this.state.taskCompleteTxtColor
                }

                let listErrStyle = {
                    fontFamily: "DM Sans",
                    color: '#724E39'
                }


                let categoryContainer = {
                    textAlign: "left",
                    marginRight: "50%",
                }

                let categoryBtn = {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                    padding: "3%",
                    border: `0px solid`,
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    marginBottom: "5.5%"
                }

                // const { width, height } = useWindowSize()

                return(
                    <Styles>
                        <div className='allTasks'>
                            <div className='taskInfo'>
                                <div className='hideItems'>
                                    {/* <button
                                    onClick={() => this.minimizeTaskCard(id, minimizeStatus)}
                                    ><label style={taskTxtColor}>{this.state.minimizeTxt}</label></button>
                                    <button
                                    onClick={() => this.turnTaskGrey(id, bgColorCode, completed)}
                                    ><label style={taskTxtColor}>{greySetting}</label></button>
                                    <button
                                    onClick={() => this.saveBtnClicked(id, saveBtn)}
                                    ><label style={taskTxtColor}>Save</label></button> */}
                                </div>
                                <div className='taskLabel'>
                                    <h5 style={txtColor} ><b>task - <label>{this.state.taskIcon}</label></b></h5>
                                </div>
                                <div className='taskData'>
                                    <div className="taskDataChild">
                                        <p>{task}
                                        <label style={taskCompleteLabel}>{this.state.taskComplete}</label></p>
                                    </div>
                                    {/* {exampleList && 
                                        <div className="taskDataChild2">
                                            <p style={taskTxtColor}>Notes</p>
                                            <textarea
                                            value={notes}
                                            readOnly/>
                                        </div>
                                    } */}
                                </div>
                                {this.state.taskButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button style={categoryBtn}>
                                                Difficulty: {difficulty}
                                            </button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{category}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{priority} 💎</button>
                                        </div>
                                        {/* {this.state.showAddExampleBtn && 
                                            <div style={categoryContainer} className='taskCategory'>
                                                <button  
                                                onClick={() => this.addingExamples(id)}
                                                style={categoryBtn}>{this.state.exampleTxt}</button>
                                            </div>
                                        } */}
                                    </div>
                                }
                                {/* {this.state.saveButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveTaskClicked(id, 
                                            saveTask, task, category, difficulty, 
                                            priority)}
                                            style={categoryBtn}
                                            >{this.state.saveTaskTxt}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveNoteClicked(id, saveNote, notes)}
                                            style={categoryBtn}
                                            >{this.state.saveNoteTxt}</button>
                                        </div>
                                    </div>
                                }   */}
                            </div>
                            <div className='markComplete'>
                                <ShowMoreText
                                /* Default options */
                                lines={1}
                                more="Add to To-do List"
                                less="Hide"
                                className="content-css"
                                anchorClass="my-anchor-css-class"
                                onClick={() => this.executeOnClick(id)}
                                expanded={false}
                                width={10}
                                truncatedEndingComponent={""}
                                >
                                {this.state.showIncompleteBtn && 
                                    <div className="taskBtnAction">
                                        {/* {this.state.showAddExamples && 
                                            <div>
                                                <button
                                                onClick={() => this.addExampleClicked(id, exampleInput)}
                                                style={completeBtnStyle}
                                                >Add Notes</button>
                                            </div>
                                        } */}
                                        <h5 style={listErrStyle}><strong>{taskErrMsg}</strong></h5>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.checkExistingTask(id, category, difficulty, priority, task)}
                                        >Add to To-do List</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTaskPermanently(id)}
                                        >Delete ❌</button>
                                    </div>
                                }
                                {this.state.confirmDelete && 
                                    <div className="taskBtnAction">
                                        <h5 style={listErrStyle}>Are you sure you want to delete this task?</h5>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTask(id)}
                                        >Yes ✅</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.cancelDelete(id)}
                                        >No ❌</button>
                                    </div>
                                }
                                {/* {this.state.writeExample && 
                                    <div className="taskBtnAction2">
                                        <div>
                                            <p style={taskTxtColor}>{exampleErrMsg}</p>
                                            <textarea
                                            rows="3"
                                            placeholder="Enter your notes --> To add to existing notes, copy and paste the notes above here, then add on to them. "
                                            id="userExampleInput"
                                            value={this.state.userExampleInput}
                                            onChange={this.handleChange}
                                            />
                                            <br/>
                                            <button
                                            onClick={() => this.submitExample(id, this.state.userExampleInput)}
                                            style={completeBtnStyle}
                                            >Update</button>
                                            <br/>
                                            <button
                                            onClick={() => this.cancelExampleInput(id)}
                                            style={completeBtnStyle}
                                            >Close</button>
                                        </div>
                                    </div>
                                } */}
                                {/* <p>{completed}</p> */}
                                </ShowMoreText>
                                <h4>*space*</h4>
                            </div>
                        </div>
                    </Styles>
                )
            })
        }
    }

    renderLPTasks = () => {
        if (this.state.lowPriorityTasks.length!= 0) {
            return this.state.lowPriorityTasks.map(tasks => {
                var {category, deleting,difficulty, 
                    id, priority, task, taskErrMsg} = tasks
                    
                if (category == "Relationships 🤝") {
                    this.state.taskIcon = "🤝"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🤝 💎"
                    }
                } else if (category == "Mental 🧠") {
                    this.state.taskIcon = "🧠"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🧠 💎"
                    }
                } else if (category == "Physical ❤️") {
                    this.state.taskIcon = "❤️"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "❤️ 💎"
                    }
                } else if (category == "Spiritual 🙏") {
                    this.state.taskIcon = "🙏"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "🙏 💎"
                    }
                } else if (category == "General 📝") {
                    this.state.taskIcon = "📝"
                    if (priority == "High Priority") {
                        this.state.taskIcon = "📝 💎"
                    }
                }


                if (deleting == false) {
                    this.state.showIncompleteBtn = true
                    this.state.confirmDelete = false
                } else {
                    this.state.showIncompleteBtn = false
                    this.state.confirmDelete = true
                }

                // if (completeBtns == false) {
                //     this.state.showIncompleteBtn = false
                // } else {
                //     this.state.showIncompleteBtn = true
                // }

                if (difficulty == "Challenging") {
                    difficulty = "🧨"
                } else if (difficulty == "Hard") {
                    difficulty = "🧨🧨"
                } else if (difficulty == "Very Hard") {
                    difficulty = "🧨🧨🧨"
                } else if (difficulty == "Super Hard") {
                    difficulty = "💣"
                }

                let taskTxtColor = {
                    fontFamily: "DM Sans"
                }

                let txtColor = {
                    color: "#724E39"
                }

                let taskCompleteLabel = {
                    marginLeft: "2%"
                }

                let completeBtnStyle = {
                    backgroundColor: this.state.taskCompleteBgColor,
                    color: this.state.taskCompleteTxtColor
                }

                let listErrStyle = {
                    fontFamily: "DM Sans",
                    color: '#724E39'
                }


                let categoryContainer = {
                    textAlign: "left",
                    marginRight: "50%",
                }

                let categoryBtn = {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                    padding: "3%",
                    border: `0px solid`,
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    marginBottom: "5.5%"
                }

                // const { width, height } = useWindowSize()

                return(
                    <Styles>
                        <div className='allTasks'>
                            <div className='taskInfo'>
                                <div className='hideItems'>
                                    {/* <button
                                    onClick={() => this.minimizeTaskCard(id, minimizeStatus)}
                                    ><label style={taskTxtColor}>{this.state.minimizeTxt}</label></button>
                                    <button
                                    onClick={() => this.turnTaskGrey(id, bgColorCode, completed)}
                                    ><label style={taskTxtColor}>{greySetting}</label></button>
                                    <button
                                    onClick={() => this.saveBtnClicked(id, saveBtn)}
                                    ><label style={taskTxtColor}>Save</label></button> */}
                                </div>
                                <div className='taskLabel'>
                                    <h5 style={txtColor} ><b>task - <label>{this.state.taskIcon}</label></b></h5>
                                </div>
                                <div className='taskData'>
                                    <div className="taskDataChild">
                                        <p>{task}
                                        <label style={taskCompleteLabel}>{this.state.taskComplete}</label></p>
                                    </div>
                                    {/* {exampleList && 
                                        <div className="taskDataChild2">
                                            <p style={taskTxtColor}>Notes</p>
                                            <textarea
                                            value={notes}
                                            readOnly/>
                                        </div>
                                    } */}
                                </div>
                                {this.state.taskButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button style={categoryBtn}>
                                                Difficulty: {difficulty}
                                            </button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{category}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{priority} 💎</button>
                                        </div>
                                        {/* {this.state.showAddExampleBtn && 
                                            <div style={categoryContainer} className='taskCategory'>
                                                <button  
                                                onClick={() => this.addingExamples(id)}
                                                style={categoryBtn}>{this.state.exampleTxt}</button>
                                            </div>
                                        } */}
                                    </div>
                                }
                                {/* {this.state.saveButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveTaskClicked(id, 
                                            saveTask, task, category, difficulty, 
                                            priority)}
                                            style={categoryBtn}
                                            >{this.state.saveTaskTxt}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveNoteClicked(id, saveNote, notes)}
                                            style={categoryBtn}
                                            >{this.state.saveNoteTxt}</button>
                                        </div>
                                    </div>
                                }   */}
                            </div>
                            <div className='markComplete'>
                                <ShowMoreText
                                /* Default options */
                                lines={1}
                                more="Add to To-do List"
                                less="Hide"
                                className="content-css"
                                anchorClass="my-anchor-css-class"
                                onClick={() => this.executeOnClick(id)}
                                expanded={false}
                                width={10}
                                truncatedEndingComponent={""}
                                >
                                {this.state.showIncompleteBtn && 
                                    <div className="taskBtnAction">
                                        {/* {this.state.showAddExamples && 
                                            <div>
                                                <button
                                                onClick={() => this.addExampleClicked(id, exampleInput)}
                                                style={completeBtnStyle}
                                                >Add Notes</button>
                                            </div>
                                        } */}
                                        <h5 style={listErrStyle}><strong>{taskErrMsg}</strong></h5>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.checkExistingTask(id, category, difficulty, priority, task)}
                                        >Add to To-do List</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTaskPermanently(id)}
                                        >Delete ❌</button>
                                    </div>
                                }
                                {this.state.confirmDelete && 
                                    <div className="taskBtnAction">
                                        <h5 style={listErrStyle}>Are you sure you want to delete this task?</h5>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTask(id)}
                                        >Yes ✅</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.cancelDelete(id)}
                                        >No ❌</button>
                                    </div>
                                }
                                {/* {this.state.writeExample && 
                                    <div className="taskBtnAction2">
                                        <div>
                                            <p style={taskTxtColor}>{exampleErrMsg}</p>
                                            <textarea
                                            rows="3"
                                            placeholder="Enter your notes --> To add to existing notes, copy and paste the notes above here, then add on to them. "
                                            id="userExampleInput"
                                            value={this.state.userExampleInput}
                                            onChange={this.handleChange}
                                            />
                                            <br/>
                                            <button
                                            onClick={() => this.submitExample(id, this.state.userExampleInput)}
                                            style={completeBtnStyle}
                                            >Update</button>
                                            <br/>
                                            <button
                                            onClick={() => this.cancelExampleInput(id)}
                                            style={completeBtnStyle}
                                            >Close</button>
                                        </div>
                                    </div>
                                } */}
                                {/* <p>{completed}</p> */}
                                </ShowMoreText>
                                <h4>*space*</h4>
                            </div>
                        </div>
                    </Styles>
                )
            })
        }
    }

    convertDate = (inputFormat) => {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(inputFormat)
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
    }

    copyMsgToClipboard = (id, copyBtn, note) => { 
        if (copyBtn == "Copy") {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("savedNotes")
            .doc(id)
            .update({
                copyMsg: "Note has been copied to clipboard ✅",
                copyBtn: "Copied ✅"
            })
            copy(note)
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("savedNotes")
            .doc(id)
            .update({
                copyMsg: "",
                copyBtn: "Copy"
            })
            copy("")
        }
        this.loadNotes(this.state.userEmail)
    }

    goToDeletingNote = (id, deleting) => {
        if (deleting == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("savedNotes")
            .doc(id)
            .update({
                deleting: true,
                copyMsg: "Are you sure you want to delete this note?"
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("savedNotes")
            .doc(id)
            .update({
                deleting: false,
                copyMsg: ""
            })
        }
        this.loadNotes(this.state.userEmail)
    }
    
    deleteNote = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedNotes")
        .doc(id).delete()

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tasks")
        .doc(id)
        .update({
            saveNote: false
        })
        this.loadNotes(this.state.userEmail)
        this.setState({deletingImage: true, showNotes: false}, () => {
            setTimeout(() => {
                this.setState({deletingImage: false, showNotes: true})
            }, 3500)
            this.loadNotes(this.state.userEmail)
        })
    }

    cancelNoteDelete = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedNotes")
        .doc(id)
        .update({
            deleting: false,
            copyMsg: "" 
        })
        this.loadNotes(this.state.userEmail)
    }

    taskSaveDemoSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("taskSaveDemo")
        .set({
            seen: true
        })
        this.setState({
            taskDemo: false
        })
        this.loadTutorials(this.state.userEmail)
    }

    noteSaveDemoSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("noteSaveDemo")
        .set({
            seen: true
        })
        this.setState({
            noteDemo: false
        })
        this.loadTutorials(this.state.userEmail)
    }

    viewNote = (id) => {
       this.setState({
           noteID: id,
           savesTitle: "View Note",
           savesPage: false,
           viewingNote: true,
           backToNotes: true
       })
       window.scrollTo(0, 0)
    }  

    renderNotes = () => {
        if (this.state.userNotes.length != 0) {
            return this.state.userNotes.map(notes => {
                var {copyBtn, copyMsg, date, deleting, id, note} = notes

                if (deleting == false) {
                    this.state.theCopyBtns = true
                    this.state.theDeleteBtns = false
                } else {
                    this.state.theCopyBtns = false
                    this.state.theDeleteBtns = true
                }

                return(
                    <Styles>
                        <div className='note'>
                            <p>{date}</p>
                            <textarea
                            readOnly
                            rows="6"
                            >{note}</textarea>
                            <div className='noteButtons'>
                                <h5>{copyMsg}</h5>
                                {this.state.theCopyBtns && 
                                    <div>
                                        <div className='noteBtn'>
                                            <button
                                            onClick={() => this.viewNote(id)}
                                            >View</button>
                                        </div>
                                        <div className='noteBtn'>
                                            <button
                                            onClick={() => this.goToDeletingNote(id, deleting)}
                                            >Delete</button>
                                        </div>
                                    </div>
                                }
                                {this.state.theDeleteBtns && 
                                    <div>
                                        <div className='noteBtn'>
                                            <button
                                            onClick={() => this.deleteNote(id)}
                                            >Yes ✅</button>
                                        </div>
                                        <div className='noteBtn'>
                                            <button
                                            onClick={() => this.cancelNoteDelete(id)}
                                            >No ❌</button>
                                        </div>
                                    </div>
                                }
                            </div>   
                        </div>
                    </Styles>
                )
            })
        }
    }


    taskBtnClicked = () => {
        if (this.state.taskBgColor == "white") {
            this.setState({
                noteBgColor: "white",
                notTxtColor: "black",
                noteBrdrColor: "black",
                taskBgColor: "#99CC63",
                taskTxtColor: "#724E39",
                taskBrdrColor: "#99CC63",
                showTasks: true,
                showNotes: false,
            })
            this.loadTasks(this.state.userEmail)
            if(this.state.taskTutorialSeen == false) {
                this.setState({
                    taskDemo: true
                })
            } else {
                return
            }
            this.loadTutorials(this.state.userEmail)
        } else {
            this.setState({
                taskBgColor: "white",
                taskTxtColor: "black",
                taskBrdrColor: "black",
                showTasks: false
            })
        }
    }

    noteBtnClicked = () => {
        if (this.state.noteBgColor == "white") {
            this.setState({
                noteBgColor: "#99CC63",
                noteTxtColor: "#724E39",
                noteBrdrColor: "#99CC63",
                taskBgColor: "white",
                taskTxtColor: "black",
                taskBrdrColor: "black",
                showTasks: false,
                showNotes: true
            })
            this.loadNotes(this.state.userEmail)
            if(this.state.noteTutorialSeen == false) {
                this.setState({
                    noteDemo: true
                })
            } else {
                return
            }
            this.loadTutorials(this.state.userEmail)
        } else {
            this.setState({
                noteBgColor: "white",
                noteTxtColor: "black",
                noteBrdrColor: "black",
                showNotes: false
            })
        }
    }

    logOut = () => {
        fire.auth().signOut()
    }

    goBackToNotes = () => {
        this.setState({
            savesPage: true,
            viewingNote: false,
            savesTitle: "Saves",
            backToNotes: false
        })
    }

    render () {

        let taskBtnStyle = { 
            backgroundColor: this.state.taskBgColor,
            color: this.state.taskTxtColor,
            border: `2px solid ${this.state.taskBrdrColor}`
        }

        let noteBtnStyle = {
            backgroundColor: this.state.noteBgColor,
            color: this.state.noteTxtColor,
            border: `2px solid ${this.state.noteBrdrColor}`
        }

        return(
            <Styles>
                <Navbar expand="lg" className="theNavbar">
                    <Navbar.Brand className='logo' href="/home">Salis</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="navLinks ms-auto">
                        <Nav.Link className="linkItem" href="/home" ><label><strong>Home</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/reads" ><label><strong>Reads</strong></label></Nav.Link> */}
                        <Nav.Link className="linkItem" onClick={this.logOut} href="/" ><label><strong>Logout</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/login" ><label>Login</label></Nav.Link> */}
                    </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <div className='header'>
                    <h1>{this.state.savesTitle}</h1>
                    {this.state.backToNotes && 
                        <div>
                            <button
                            onClick={this.goBackToNotes}
                            >Back to Notes</button>
                        </div>
                    }
                </div>
                {this.state.savesPage && 
                    <div>
                        <div className='categoryBtns'>
                            <div className='cBtn'>
                                <button
                                onClick={this.taskBtnClicked}
                                style={taskBtnStyle}
                                ><strong>Tasks</strong></button>
                            </div>
                            <div className='cBtn'>
                                <button
                                onClick={this.noteBtnClicked}
                                style={noteBtnStyle}
                                ><strong>Notes</strong></button>
                            </div>
                            {this.state.taskDemo &&
                                <div>
                                    <ReactDialogBox
                                    className="modalDialogBox"
                                    closeBox={this.taskSaveDemoSeen}
                                    modalWidth='80%'
                                    headerBackgroundColor='#99CC63'
                                    headerTextColor='#FFCC59'
                                    headerFont='DM Sans'
                                    headerHeight='40'
                                    closeButtonColor='white'
                                    bodyBackgroundColor='white'
                                    bodyTextColor='black'
                                    bodyHeight='100%'
                                    headerText=""
                                    overflow-y= "scroll"
                                    >
                                    <div className="maximizeDialogBox">
                                        <h4>You can view your saved tasks here and add them to your to your to-do list</h4>
                                        <p>See how to do this below 👀</p>
                                        <video autoPlay muted loop playsInline>
                                            <source src="/assets/saveDemo2.mp4" type="video/mp4"/>
                                        </video>
                    
                                    </div>
                                    </ReactDialogBox>
                                </div>
                            }  
                            {this.state.noteDemo &&
                                <div>
                                    <ReactDialogBox
                                    className="modalDialogBox"
                                    closeBox={this.noteSaveDemoSeen}
                                    modalWidth='80%'
                                    headerBackgroundColor='#99CC63'
                                    headerTextColor='#FFCC59'
                                    headerFont='DM Sans'
                                    headerHeight='40'
                                    closeButtonColor='white'
                                    bodyBackgroundColor='white'
                                    bodyTextColor='black'
                                    bodyHeight='100%'
                                    headerText=""
                                    overflow-y= "scroll"
                                    >
                                    <div className="maximizeDialogBox">
                                        <h4>You can view notes that you've saved from tasks here - it's kinda like bite-sized journalling!</h4>
                                        <p>See how to do this below 👀</p>
                                        <video autoPlay muted loop playsInline>
                                            <source src="/assets/saveDemo3.mp4" type="video/mp4"/>
                                        </video>
                    
                                    </div>
                                    </ReactDialogBox>
                                </div>
                            }  
                        </div>
                        {this.state.showTasks && 
                            <div>
                                {this.renderHPTasks()}
                                {this.renderLPTasks()}
                            </div>
                        }
                        {this.state.showNotes && 
                            <div className='noteContainer'>
                                <h4><b>Feel free to use any reflections saved below to piece together a journal entry (📖) in another doc (💻) or in your notes app (📱).</b></h4>
                                {this.renderNotes()}
                            </div>
                        }
                        {this.state.deletingImage && 
                            <div className='noteContainer'>
                                <img src="assets/deleteImg.png"/>  
                            </div>
                        }
                    </div>
                }
                {this.state.viewingNote && 
                    <div>
                        <ViewNote
                        dataSentFromParent = {this.state.noteID}
                        />
                    </div>
                }
            </Styles>
        )
    }
}